"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const ActionText_1 = __importDefault(require("../styled/ActionText"));
const renderTitle_1 = __importDefault(require("../utils/renderTitle"));
const Action = props => {
    const { action, actionTarget = '_self', isDisabled = false, shouldWrapText = false, testId = 'LABEL', children, } = props;
    const handleOnClick = (event) => {
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        if ((0, lodash_isfunction_1.default)(action)) {
            event.preventDefault();
            action(event);
        }
    };
    return (react_1.default.createElement(ActionText_1.default, { tabIndex: 0, as: (0, lodash_isfunction_1.default)(action) ? 'button' : undefined, type: (0, lodash_isfunction_1.default)(action) ? 'button' : undefined, "aria-disabled": isDisabled, ...(0, oxygen_config_1.getTestAttributes)(`${testId}_ACTION`), ...(actionTarget && { target: `${actionTarget}` }), ...{ [(0, lodash_isfunction_1.default)(action) ? 'onClick' : 'href']: action }, title: (0, renderTitle_1.default)(children), isDisabled: isDisabled, shouldWrapText: shouldWrapText, onClick: handleOnClick }, children));
};
exports.default = Action;
